import Sketch from "react-p5";

const Sphere = ({ parentRef, text1, text2 }) => {
  let angle; // Initial angles for the first circular path
  let myFont;
  let sphereRadius = 100;
  let textTexture; // Array to store text textures
  const preload = (p5) => {
    myFont = p5.loadFont("Poppins.ttf");
  };
  const setup = (p5, canvasParentRef) => {
    // Attach the canvas to the canvasParentRef
    p5.createCanvas(300, 300, p5.WEBGL).parent(canvasParentRef);
    p5.textureMode(p5.NORMAL);
    angle = p5.TWO_PI / (p5.random() * 10);
    let txt = p5.createGraphics(400, 400);
    txt.pixelDensity(2);
    txt.textFont(myFont);
    txt.textSize(16);
    txt.textAlign(p5.CENTER, p5.CENTER);
    txt.background(143, 214, 225);
    txt.fill(50, 30, 30);
    if (text1) {
      txt.text(
        text1, // "ReactJs | NextJs     ReactJs | NextJs",
        txt.width / 2,
        txt.height / 2 - 15
      );
    }
    if (text2) {
      txt.text(
        text2, // "Angular            Angular",
        txt.width / 2,
        txt.height / 2 + 15
      );
    }
    textTexture = txt;
  };
  const draw = (p5) => {
    p5.background(18);
    // p5.background(0, 0, 255);
    p5.push();
    p5.rotateY(angle);
    p5.texture(textTexture);
    p5.noStroke();
    p5.sphere(sphereRadius);
    p5.pop();
    angle += 0.01;
  };

  return <Sketch ref={parentRef} setup={setup} draw={draw} preload={preload} />;
};

export default Sphere;
